module.exports = __webpack_public_path__ + "media/images/job_list/icon_human-86ed88ed012e4c045815f0607820f70c.png";